"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var selectMessageAd_1 = require("./actions/selectMessageAd");
exports.selectMessageAd = selectMessageAd_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-messagead-action/lib/index.js
// module id = 6018
// module chunks = 67